import axios from 'axios'

import { Message } from 'view-design'
import {
  encryptFunc
  // decryptFunc
} from '@/utils/globalTools'

// import md5 from 'js-md5';

// import { sortByKey } from '@/utils/validate';

// 公钥

// 参数加密
// let pki = null
// let publicKeyRsa = null
// let privateKeyRsa = null
// if (window.forge) {
//   pki = window.forge.pki
//   publicKeyRsa = pki.publicKeyFromPem(publicKey)
//   privateKeyRsa = pki.privateKeyFromPem(privateKey)
// }
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_JAVA,
  timeout: 60000
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    const thisConfig = config
    const loginType = JSON.parse(window.localStorage.getItem('loginType')) || {}
    thisConfig.headers = {
      ...loginType,
      // 'client-id': 'webApp',
      // 'client-secret': 'webApp',
      'Content-Type': 'application/json',
      'access-token': window.localStorage.getItem('access-token') || ''
    }
    // if (process.env.NODE_ENV !== 'sit') {
    if (process.env.NODE_ENV === '需要的时候') {
      let encryptStr
      if (config.data) {
        encryptStr = encryptFunc({ a: 1, b: 2 })
        config.data = { encryptStr }
      }
    }

    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const { data } = response

    // if (encryptStr) {
    //   console.log(decryptFunc(encryptStr))
    // }

    return Promise.resolve(data)
  },
  (error) => {
    console.log(error, '==')
    const respData = error?.response?.data || {}
    const warnMsg = respData.msg || respData.msgDetail || respData.describe || '服务器异常，建议稍后重试'
    if (error?.response?.status === 401) {
      window.localStorage.removeItem('access-token') // 清除数据
      window.localStorage.removeItem('userInfo') // 清除数据
      // if (error.response.data.msg === '当前未登录, 请先登录') {
      //   setTimeout(() => {
      //     window.location.href = `${window.location.origin}/login`
      //   }, 200)
      // }
      if (!window.location.pathname.includes('login') && !window.location.pathname.includes('home')) {
        setTimeout(() => {
          // window.location.href = window.location.origin
          window.location.href = `${window.location.origin}/login?${window.location.pathname}${window.location.search}`
        }, 200)
      }
      Message.warning(warnMsg)
    } else if (error?.response?.status === 500) {
      console.error(500)
      Message.warning(warnMsg)
    } else {
      Message.warning(warnMsg)
    }
    // Message.warning(error.response.data.msgDetail || error.response.data.msg)
    console.error({
      message: '服务器异常，建议稍后重试',
      duration: 5 * 1000,
      closable: true
    })
    return Promise.reject(error)
  }
)

const fetch = (method, url, data) => {
  let thisReturnData = ''
  if (method === 'post') {
    if (Array.isArray(data)) {
      thisReturnData = service.post(url, [...data])
    } else {
      thisReturnData = service.post(url, { ...data })
    }
  } else if (method === 'get') {
    thisReturnData = service.get(url, {
      params: data
    })
  } else if (method === 'put') {
    thisReturnData = service.put(url, { ...data })
  } else if (method === 'delete') {
    console.log(service.delete, 'service.delete')
    thisReturnData = service.delete(url, {
      params: data
    })
  }
  return thisReturnData
}

export default fetch
